// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__j4F9F","user_profile_image":"UserInfo_user_profile_image__qHUFZ","header":"UserInfo_header__v5Fe9","main":"UserInfo_main__gzwZy"};